import httpClient from "@/plugins/axios";

export const getFeedbackPolicy = async () => {
    const response = await httpClient.get(`/v1/settings/feedback-policy/?admin_view=1`);
    return response;
}
export const saveFeedbackPolicy = async (policyTranslastions) => {
    const response = await httpClient.patch(`/v1/settings/feedback-policy/?admin_view=1`, policyTranslastions);
    return response;
}